import React from "react";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../components/button";
import CustomModal from "../../../../../components/modal/modal-core";
import { getSurveyQuestionTypes, type SurveyQuestionType } from "../../data";

interface QuestionAddProps {
  onAddQuestion: (type: SurveyQuestionType) => void;
  disabled?: boolean;
}

export function QuestionAdd({ onAddQuestion, disabled = false }: QuestionAddProps) {
  const { t } = useTranslation();
  const [addQuestionDialogOpen, setAddQuestionDialogOpen] = React.useState(false);
  const questionTypes = getSurveyQuestionTypes(t);

  const handleSelectQuestionType = (type: SurveyQuestionType) => {
    onAddQuestion(type);
    setAddQuestionDialogOpen(false);
  };

  return (
    <>
      <Button
        className="flex items-center gap-2 bg-emerald-500 text-white hover:bg-emerald-600 shadow-sm rounded-lg"
        onClick={() => setAddQuestionDialogOpen(true)}
        disabled={disabled}
      >
        <Plus className="h-4 w-4" />
        Add Question
      </Button>

      <CustomModal
        isOpen={addQuestionDialogOpen}
        onClose={() => setAddQuestionDialogOpen(false)}
        title="Add Question"
        description="Choose a question type to add to your survey"
        maxWidth="md"
        contentClassName="pt-4"
      >
        <div className="grid grid-cols-2 gap-2 max-h-96 overflow-y-auto">
          {questionTypes.map((type) => (
            <Button
              key={type.value}
              variant="outline"
              className="h-auto p-4 flex flex-col items-center gap-2"
              onClick={() => handleSelectQuestionType(type.value)}
            >
              <span className="text-2xl">{type.icon}</span>
              <span className="text-sm text-center">{type.label}</span>
            </Button>
          ))}
        </div>
      </CustomModal>
    </>
  );
}

export default QuestionAdd;
